import Page from "components/Page";
import { lazyWithRetry } from "helpers/lazyWithRetry";
import { ContactListProps } from "./Contacts.types";

const Contacts = lazyWithRetry(() => import("./ContactsList"));

export default (props: ContactListProps) => (
  <Page>
    <Contacts {...props} />
  </Page>
);
